import { useCallback } from "react";
import { SideNav } from "react-migration/components/SideNav";
import { hasBetaFeature, hasFeature } from "src/js/stores/user/actions";
import { Feature } from "src/js/stores/user";
import ROUTES from "src/js/router/routes";
import { router } from "src/js/router/react-router";
import { useTranslation } from "react-migration/lib";
import { twMerge } from "tailwind-merge";

type DashboardSidebarProps = {
  active: string;
};

export const DashboardSidebar = ({ active }: DashboardSidebarProps) => {
  const { t } = useTranslation();
  const navigate = useCallback(
    (to: string) => {
      if (to !== active) {
        router.push({ name: to });
      }
    },
    [active]
  );

  const menuItemClasses = (item: string) =>
    twMerge(
      "atlas-text-neutral-400 atlas-cursor-pointer hover:atlas-text-neutral-800 atlas-p-1",
      active === item &&
        "atlas-text-neutral-800 atlas-border-[2px] atlas-p-[2px] atlas-border-neutral-100 atlas-rounded"
    );
  return (
    <>
      <SideNav
        expanded
        className="atlas-pointer-events-auto atlas-w-[200px] atlas-hidden sm:atlas-flex"
      >
        <SideNav.Content>
          <SideNav.Item
            dataTestID="menu-item-landtech-balance"
            icon="atlas-hidden"
            text={t("dashboard.dashboard.landtech_balance")}
            expanded
            active={active === ROUTES.DASHBOARD_TOPUP}
            onClick={() => navigate(ROUTES.DASHBOARD_TOPUP)}
          />
          {hasFeature(Feature.planningAlerts) && (
            <SideNav.Item
              dataTestID="menu-item-planning-alerts"
              icon="atlas-hidden"
              text={t("dashboard.dashboard.planning_alerts")}
              expanded
              active={active === ROUTES.DASHBOARD_PLANNING_ALERTS}
              onClick={() => navigate(ROUTES.DASHBOARD_PLANNING_ALERTS)}
            />
          )}
          {hasFeature(Feature.ownershipChangeAlerts) && (
            <SideNav.Item
              dataTestID="menu-item-ownership-alerts"
              icon="atlas-hidden"
              text={t("dashboard.dashboard.ownership_alerts")}
              expanded
              active={active === ROUTES.DASHBOARD_OWNERSHIP_ALERTS}
              onClick={() => navigate(ROUTES.DASHBOARD_OWNERSHIP_ALERTS)}
            />
          )}
          <SideNav.Item
            dataTestID="menu-item-purchased-documents"
            icon="atlas-hidden"
            text={t("dashboard.dashboard.purchased_documents")}
            expanded
            active={active === ROUTES.DASHBOARD_DOCUMENTS}
            onClick={() => navigate(ROUTES.DASHBOARD_DOCUMENTS)}
          />
          <SideNav.Item
            dataTestID="menu-item-your-addresses"
            icon="atlas-hidden"
            text={t("dashboard.dashboard.your_addresses")}
            expanded
            active={active === ROUTES.DASHBOARD_YOUR_ADDRESS}
            onClick={() => navigate(ROUTES.DASHBOARD_YOUR_ADDRESS)}
          />
          {hasBetaFeature(Feature.integrationsDashboardBeta) && (
            <SideNav.Item
              dataTestID="menu-item-integrations"
              icon="atlas-hidden"
              text={t("dashboard.dashboard.integrations")}
              expanded
              active={active === ROUTES.DASHBOARD_INTEGRATIONS}
              onClick={() => navigate(ROUTES.DASHBOARD_INTEGRATIONS)}
            />
          )}
        </SideNav.Content>
      </SideNav>
      <div className="atlas-flex atlas-flex-wrap atlas-justify-center atlas-m-[5px] atlas-items-center atlas-text-xs sm:atlas-text-base sm:atlas-hidden">
        <div
          className={menuItemClasses(ROUTES.DASHBOARD_TOPUP)}
          onClick={() => navigate(ROUTES.DASHBOARD_TOPUP)}
        >
          {t("dashboard.dashboard.landtech_balance")}
        </div>
        {hasFeature(Feature.planningAlerts) && (
          <div
            className={menuItemClasses(ROUTES.DASHBOARD_PLANNING_ALERTS)}
            onClick={() => navigate(ROUTES.DASHBOARD_PLANNING_ALERTS)}
          >
            {t("dashboard.dashboard.planning_alerts")}
          </div>
        )}
        {hasFeature(Feature.ownershipChangeAlerts) && (
          <div
            className={menuItemClasses(ROUTES.DASHBOARD_OWNERSHIP_ALERTS)}
            onClick={() => navigate(ROUTES.DASHBOARD_OWNERSHIP_ALERTS)}
          >
            {t("dashboard.dashboard.ownership_alerts")}
          </div>
        )}
        <div
          className={menuItemClasses(ROUTES.DASHBOARD_DOCUMENTS)}
          onClick={() => navigate(ROUTES.DASHBOARD_DOCUMENTS)}
        >
          {t("dashboard.dashboard.purchased_documents")}
        </div>
        <div
          className={menuItemClasses(ROUTES.DASHBOARD_YOUR_ADDRESS)}
          onClick={() => navigate(ROUTES.DASHBOARD_YOUR_ADDRESS)}
        >
          {t("dashboard.dashboard.your_addresses")}
        </div>
        {hasBetaFeature(Feature.integrationsDashboardBeta) && (
          <div
            className={menuItemClasses(ROUTES.DASHBOARD_INTEGRATIONS)}
            onClick={() => navigate(ROUTES.DASHBOARD_INTEGRATIONS)}
          >
            {t("dashboard.dashboard.integrations")}
          </div>
        )}
      </div>
    </>
  );
};
